type ClipboardMenuItem = 'cut' | 'copy' | 'paste';

const CLIPBOARD_CONTEXT_MENU_ITEMS: readonly ClipboardMenuItem[] = ['cut', 'copy'];

/**
 * `getContextMenuItems` behind the shared grids' `enableClipboardContextMenu` prop: Cut, Copy and
 * Paste on a cell, nothing anywhere else. Returns AG Grid's built-in item names, so it fits both the
 * v32 (AGGridTable) and v35 (BombiixAGGrid) callback signatures. AG Grid greys out Cut and Paste on
 * read-only cells, and AG Grid 32 always greys out Paste.
 *
 * Paste is offered only where the async Clipboard API exists (HTTPS or localhost). Without it AG Grid
 * falls back to a hidden-textarea paste that reads an empty string and writes it into the cell, so a
 * menu Paste on a plain-HTTP host silently blanked the value instead of pasting.
 * @param params - AG Grid context-menu params; only the clicked column is read.
 * @returns the items for a clicked cell, or an empty list when the click was not on a cell.
 */
export function getClipboardContextMenuItems({ column }: { column?: unknown }): ClipboardMenuItem[] {
  if (!column) return [];
  return canReadClipboard() ? [...CLIPBOARD_CONTEXT_MENU_ITEMS, 'paste'] : [...CLIPBOARD_CONTEXT_MENU_ITEMS];
}

/**
 * Whether the browser exposes `navigator.clipboard.readText`, which AG Grid's menu Paste needs to read
 * real clipboard content.
 * @returns true in a secure context with the async Clipboard API available.
 */
function canReadClipboard(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.clipboard?.readText === 'function';
}
